import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { authServiceProvider } from 'angular/angularjs-upgraded.providers';
import { MultiYearBidEditorComponent } from 'angular/auctions/multi-year/multi-year-bid-editor.component';
import { MultiYearBidOverviewComponent } from 'angular/auctions/multi-year/multi-year-bid-overview.component';
import { MultiYearCapacityDetailsComponent } from 'angular/auctions/multi-year/multi-year-capacity-details.component';
import { MultiYearCapacityComponent } from 'angular/auctions/multi-year/multi-year-capacity.component';
import { CustomModule } from 'angular/custom/custom.module';

@NgModule({
    imports: [BrowserModule, FormsModule, CustomModule],
    providers: [authServiceProvider],
    declarations: [
        MultiYearBidEditorComponent,
        MultiYearBidOverviewComponent,
        MultiYearCapacityComponent,
        MultiYearCapacityDetailsComponent
    ],
    exports: [
        MultiYearBidEditorComponent,
        MultiYearBidOverviewComponent,
        MultiYearCapacityComponent,
        MultiYearCapacityDetailsComponent
    ],
    entryComponents: [
        MultiYearCapacityComponent,
        MultiYearCapacityDetailsComponent
    ]
})
export class MultiYearModule {}
